import React from "react"
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner'
import RatesDashboard from '../RatesDashboard/RatesDashboard'

class RatesDashboardWidget extends React.Component {
  
  constructor(props) {
    super(props)

    this.state = {
      data: null,
      loading: true,
    }
  }

  componentDidMount() {
    this.load();
  }

  render() {
    return (
      <div className={"RatesDashboardWidget WidgetComponent " + (this.state.loading ? 'loading ' : ' ')}>
        {
          this.state.data
          ?
          <RatesDashboard {...this.state.data} />
          :
          null
        }
        <LoadingSpinner size="small" show={this.state.loading} />
      </div>
    );
  }

  load() {
    var self = this;
    this.setState({loading: true});
    $.ajax({
      type: 'POST',
      url: '/admin/rates-dashboard-widget',
    }).done((data) => {
      self.setState({loading: false, data: data});
    });
  }

}

export default RatesDashboardWidget